/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalSystemEnum } from './externalSystemEnum';
import { AvailabilityModeEnum } from './availabilityModeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface AvailabilityWindow { 
    readonly id: number;
    windowDate: string;
    fromTime: string;
    toTime: string;
    scheduleId?: number | null;
    availabilityMode: AvailabilityModeEnum;
    externalSystem?: ExternalSystemEnum | null;
    externalSystemAvailabilityId?: string;
}
export namespace AvailabilityWindow {
}

export const AvailabilityWindow_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindow_windowDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindow_fromTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindow_toTime_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindow_scheduleId_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityWindow_availabilityMode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AvailabilityWindow_externalSystem_Validators: ValidatorFn[] =
    [ ];

export const AvailabilityWindow_externalSystemAvailabilityId_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];


